var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedals(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 77,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E70B6A",
    d: "M36.434 52l-3.261 1.035.07.217-9.613 4.526-1.63.518L27.065 74l6.556-5.197L42 69.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD4A4A",
    d: "M21.37 57.778l-9.613-4.526.07-.217L8.567 52 3 69.26l8.38-.457L17.934 74 23 58.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD92D",
    d: "M43.153 39L45 44.118l-3.888 3.816-.573 5.408-5.162 1.754-2.863 4.631-5.417-.652L22.5 62l-4.597-2.925-5.417.652-2.863-4.63-5.162-1.755-.573-5.408L0 44.118 1.847 39 0 33.882l3.888-3.817.573-5.407 5.162-1.755 2.863-4.63 5.417.652L22.5 16l4.597 2.925 5.417-.652 2.863 4.63 5.162 1.755.573 5.407L45 33.882z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBE00",
    d: "M43.112 39L45 44.118l-3.975 3.816-.585 5.408-5.276 1.754-2.927 4.631-5.538-.652L22 62V16l4.7 2.925 5.537-.652 2.927 4.63 5.276 1.755.585 5.407L45 33.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 39c0 7.72-6.28 14-14 14S8 46.72 8 39s6.28-14 14-14 14 6.28 14 14z",
    fill: "#FFB615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 39c0 7.72-6.28 14-14 14V25c7.72 0 14 6.28 14 14z",
    fill: "#FF8400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E70B6A",
    d: "M90.434 36l-3.261 1.035.07.217-9.613 4.526-1.63.518L81.065 58l6.556-5.197L96 53.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD4A4A",
    d: "M75.37 41.778l-9.613-4.526.07-.217L62.567 36 57 53.26l8.38-.457L71.934 58 77 42.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD92D",
    d: "M97.153 23L99 28.118l-3.888 3.816-.573 5.408-5.162 1.754-2.863 4.631-5.417-.652L76.5 46l-4.597-2.925-5.417.652-2.863-4.63-5.162-1.755-.573-5.408L54 28.118 55.847 23 54 17.882l3.888-3.817.573-5.407 5.162-1.755 2.863-4.63 5.417.652L76.5 0l4.597 2.925 5.417-.652 2.863 4.63 5.162 1.755.573 5.407L99 17.882z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBE00",
    d: "M97.112 23L99 28.118l-3.975 3.816-.585 5.408-5.276 1.754-2.927 4.631-5.538-.652L76 46V0l4.7 2.925 5.537-.652 2.927 4.63 5.276 1.755.585 5.407L99 17.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 23c0 7.72-6.28 14-14 14s-14-6.28-14-14S68.28 9 76 9s14 6.28 14 14z",
    fill: "#FFB615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 23c0 7.72-6.28 14-14 14V9c7.72 0 14 6.28 14 14z",
    fill: "#FF8400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E70B6A",
    d: "M141.434 55l-3.261 1.035.07.217-9.613 4.526-1.63.518L132.065 77l6.556-5.197 8.379.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD4A4A",
    d: "M126.37 60.778l-9.613-4.526.07-.217-3.26-1.035L108 72.26l8.38-.457L122.934 77 128 61.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD92D",
    d: "M148.153 42L150 47.118l-3.888 3.816-.573 5.408-5.162 1.754-2.863 4.631-5.417-.652L127.5 65l-4.597-2.925-5.417.652-2.863-4.63-5.162-1.755-.573-5.408L105 47.118 106.847 42 105 36.882l3.888-3.817.573-5.407 5.162-1.755 2.863-4.63 5.417.652L127.5 19l4.597 2.925 5.417-.652 2.863 4.63 5.162 1.755.573 5.407L150 36.882z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBE00",
    d: "M148.112 42L150 47.118l-3.975 3.816-.585 5.408-5.276 1.754-2.927 4.631-5.538-.652L127 65V19l4.7 2.925 5.537-.652 2.927 4.63 5.276 1.755.585 5.407L150 36.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 42c0 7.72-6.28 14-14 14s-14-6.28-14-14 6.28-14 14-14 14 6.28 14 14z",
    fill: "#FFB615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 42c0 7.72-6.28 14-14 14V28c7.72 0 14 6.28 14 14z",
    fill: "#FF8400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedals);
export default __webpack_public_path__ + "static/media/medals.4d9d08109c822523d64918f232dccbcc.svg";
export { ForwardRef as ReactComponent };